<template>
    <div class="container">
        <loader :active="loading"/>

        <header class="jumbotron">
            <div class="info">
                <div class="info-head">
                    <font-awesome-icon icon="sitemap"/>
                    <h3>Zarządzanie kanałami strefy</h3></div>
                <small>Poniżej możesz zarządzać kanałami strefy.</small><br>
                <small>Maksymalna liczba podkanałow zależy od kanału głównego. Jeśli potrzebujesz większej ilości zgłoś
                    się do administratora.</small><br>
                <small>Możesz zarządzać tylko kanałami, które nie mają przypisanej żadnej funkcji (np. licznik osób
                    online).</small><br>
                <small>Możesz usuwać i dodawać tylko podkanały.</small><br>
                <small>Poniżej możesz zarządzać grupami kanałowymi.</small><br>
                <small>Podkanały możesz przesuwać przytrzymując ikonkę strzałek.</small>
            </div>
            <refresh :func="refresh"/>
        </header>

        <div class="row">
            <div class="col-md-6">
                <div class="card position-sticky">
                    <div class="card-header">
                        <h5> Twoje kanały </h5>
                    </div>

                    <div class="card-body">
                        <div class="ts-channels">
                            <ul class="channels-list">
                                <channel v-for="channel in channels" :key="channel.cid" :add-func="addSubChannel"
                                         :add-sub-channel="canAddSubChannel(channel)" :channel="channel" :current="currentChannel"
                                         :func="setSettings" :is-parent="true"
                                         :moved-func="movedSubChannel"></channel>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-md-6">

                <div class="card">
                    <form v-if="editForm" data-vv-scope="edit" name="form" @submit.prevent="saveChannel">
                        <div class="card-header">
                            <h5> Ustawienia kanału <span v-if="currentChannel">`{{
                                    currentChannel.name
                                }}` ( id: {{ currentChannel.cid }} )</span></h5>
                            <small>Kliknij kanał po lewej</small>
                        </div>

                        <div class="card-body">
                            <div v-if="currentChannel">
                                <div class="form-group">
                                    <label for="name">Nazwa kanału</label>
                                    <input
                                        v-model="currentChannel.name"
                                        v-validate="'required|min:3|max:40'"
                                        class="form-control"
                                        name="name"
                                        type="text"
                                    />
                                    <div
                                        v-if="errors.has('edit.name')"
                                        class="alert alert-danger"
                                        role="alert"
                                    >{{ errors.first('edit.name') }}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="topic">Topic</label>
                                    <input
                                        v-model="currentChannel.topic"
                                        v-validate="'min:3|max:40'"
                                        class="form-control"
                                        name="topic"
                                        type="text"
                                    />
                                    <div
                                        v-if="errors.has('edit.topic')"
                                        class="alert alert-danger"
                                        role="alert"
                                    >{{ errors.first('edit.topic') }}
                                    </div>
                                </div>

                                <div v-if="!currentChannel.flagPassword" class="form-group">
                                    <label for="password">Hasło kanału</label>
                                    <input
                                        v-model="currentChannel.password"
                                        v-validate="'min:6|max:20'"
                                        class="form-control"
                                        name="password"
                                        type="text"
                                    />
                                    <div
                                        v-if="errors.has('edit.password')"
                                        class="alert alert-danger"
                                        role="alert"
                                    >{{ errors.first('edit.password') }}
                                    </div>
                                </div>

                                <div v-else class="form-group">
                                    <label for="delete-password">Usuń hasło</label>
                                    <input
                                        v-model="currentChannel.deletePassword"
                                        class="form-control"
                                        name="deletePassword"
                                        type="checkbox"
                                    />
                                </div>

                                <div class="form-group">
                                    <label for="maxClients">Maksymalna liczba klientów</label>
                                    <input
                                        v-model="currentChannel.maxClients"
                                        v-validate="'integer|required|between:-1,100'"
                                        class="form-control"
                                        name="maxClients"
                                        type="number"
                                    />
                                    <small>-1: nielimitowana liczba | 0: kanał czerwony</small>
                                    <div
                                        v-if="errors.has('edit.maxClients')"
                                        class="alert alert-danger"
                                        role="alert"
                                    >{{ errors.first('edit.maxClients') }}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="description">Opis kanału</label>
                                    <textarea
                                        v-model="currentChannel.description"
                                        v-validate="'min:3|max:2000'"
                                        class="form-control"
                                        name="description"
                                    ></textarea>
                                    <div
                                        v-if="errors.has('edit.description')"
                                        class="alert alert-danger"
                                        role="alert"
                                    >{{ errors.first('edit.description') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="currentChannel" class="card-footer">
                            <button :disabled="loading" class="btn btn-success">
                                <span><font-awesome-icon icon="check"/> Zapisz</span>
                            </button>
                            <button v-if="canBeDeleted()" :disabled="loading" class="btn btn-danger"
                                    @click.prevent="deleteSubChannel">
                                <span><font-awesome-icon icon="trash"/> Usuń</span>
                            </button>
                            <button :disabled="loading" class="btn btn-primary" @click.prevent="createMeeting">
                                <span><font-awesome-icon icon="users"/> Utwórz spotkanie</span>
                            </button>
                        </div>
                    </form>

                    <form v-else data-vv-scope="add" name="form" @submit.prevent="saveAddSubChannel">
                        <div class="card-header">
                            <h5> Dodajesz nowy podkanał </h5>
                        </div>

                        <div class="card-body">
                            <div class="form-group">
                                <label for="name">Nazwa kanału</label>
                                <input
                                    v-model="newSubChannel.name"
                                    v-validate="'required|min:3|max:40'"
                                    class="form-control"
                                    name="name"
                                    type="text"
                                />
                                <div
                                    v-if="errors.has('add.name')"
                                    class="alert alert-danger"
                                    role="alert"
                                >{{ errors.first('add.name') }}
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="topic">Topic</label>
                                <input
                                    v-model="newSubChannel.topic"
                                    v-validate="'min:3|max:40'"
                                    class="form-control"
                                    name="topic"
                                    type="text"
                                />
                                <div
                                    v-if="errors.has('add.topic')"
                                    class="alert alert-danger"
                                    role="alert"
                                >{{ errors.first('add.topic') }}
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="password">Hasło kanału</label>
                                <input
                                    v-model="newSubChannel.password"
                                    v-validate="'min:6|max:20'"
                                    class="form-control"
                                    name="password"
                                    type="text"
                                />
                                <div
                                    v-if="errors.has('add.password')"
                                    class="alert alert-danger"
                                    role="alert"
                                >{{ errors.first('add.password') }}
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="maxClients">Maksymalna liczba klientów</label>
                                <input
                                    v-model="newSubChannel.maxClients"
                                    v-validate="'required|integer|between:-1,100'"
                                    class="form-control"
                                    name="maxClients"
                                    type="number"
                                />
                                <small>-1: nielimitowana liczba | 0: kanał czerwony</small>
                                <div
                                    v-if="errors.has('add.maxClients')"
                                    class="alert alert-danger"
                                    role="alert"
                                >{{ errors.first('add.maxClients') }}
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="description">Opis kanału</label>
                                <textarea
                                    v-model="newSubChannel.description"
                                    v-validate="'min:3|max:2000'"
                                    class="form-control"
                                    name="description"
                                ></textarea>
                                <div
                                    v-if="errors.has('add.description')"
                                    class="alert alert-danger"
                                    role="alert"
                                >{{ errors.first('add.description') }}
                                </div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <button :disabled="loading" class="btn btn-success">
                                <span><font-awesome-icon icon="plus"/> Dodaj</span>
                            </button>
                        </div>
                    </form>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h5> Ustawienia grup kanałowych <span v-if="currentChannel">`{{
                                currentChannel.name
                            }}` ( id: {{ currentChannel.cid }} )</span></h5>
                        <small>Kliknij kanał po lewej</small>
                    </div>

                    <div class="card-body">
                        <loader :active="loadingSingleChannel"/>

                        <div v-if="currentChannel && currentChannel.groupClientList">
                            <div class="form-group mb-5">
                                <select v-model="currentGroupId" class="form-control">
                                    <option value="0">Wybierz grupę</option>
                                    <option v-for="(group, groupId) in currentChannel.groupClientList" :key="groupId"
                                            :value="groupId">{{ group.name + ' (Osób: ' + group.clients.length + ')' }}
                                    </option>
                                </select>
                            </div>

                            <div v-for="(group, groupId) in currentChannel.groupClientList" :key="groupId">
                                <div v-if="currentGroupId == groupId">
                                    <table v-if="group.clients.length" class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <td><strong>Klient</strong></td>
                                            <td><strong>Opcja</strong></td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="client in group.clients" :key="client.dbid">
                                            <td><span v-tooltip="'Database id: ' + client.dbid"
                                                      class="badge badge-info">{{ client.nick }}</span></td>
                                            <td>
                                                <button class="btn btn-danger"
                                                        @click="deleteClientChannelGroup(groupId, client.dbid)">Usuń
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div v-else class="text-center">
                                        <h5>Brak klientów w tej grupie</h5>
                                    </div>

                                    <div class="text-center mt-5">
                                        <button class="btn btn-success" @click="addClientChannelGroup(groupId)">
                                            <font-awesome-icon icon="plus"/>
                                            Dodaj użytkownika
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import ManageChannelsService from '../services/manageChannels.service';
import Vue from "vue";
import SelectOnline from "../components/SelectOnline";

export default {
    name: 'ManageChannels',
    data() {
        return {
            loading: true,
            loadingSingleChannel: false,
            channels: [],
            currentChannel: null,
            editForm: true,
            newSubChannel: {},
            currentGroupId: 0,
        };
    },
    mounted() {
        this.refresh();
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        premiumChannel() {
            return this.$store.state.auth.premiumChannel;
        },
    },
    methods: {
        refresh() {
            let currentId = this.currentChannel ? this.currentChannel.cid : null;
            this.loading = true;
            this.currentChannel = null;
            this.editForm = true;

            ManageChannelsService.getChannels().then(
                response => {
                    this.channels = response.data.channels;
                    if (currentId)
                        this.setSettings(currentId);

                    this.loading = false;
                },
                error => {
                    this.loading = false;
                    console.log(error)
                }
            );
        },
        getSingleChannel(cid) {
            ManageChannelsService.getSingleChannel(cid).then(
                response => {
                    this.currentChannel.groupClientList = response.data.groupClientList;
                    this.loadingSingleChannel = false;
                },
                error => {
                    this.loadingSingleChannel = false;
                    console.log(error)
                }
            );
        },
        setSettings(cid) {
            this.editForm = true;
            this.loadingSingleChannel = true;
            this.getSingleChannel(cid);
            this.chooseCurrentChannel(cid, this.channels);
        },
        chooseCurrentChannel(cid, channels) {
            for (let channel of channels) {
                if (channel.cid == cid) {
                    this.currentChannel = channel;
                    break;
                } else
                    this.chooseCurrentChannel(cid, channel.children);
            }
        },
        saveChannel() {
            this.loading = true;
            this.$validator.validateAll('edit').then(isValid => {
                if (!isValid) {
                    this.loading = false;
                    return;
                }

                if (this.currentChannel) {
                    ManageChannelsService.saveChannel(this.currentChannel).then(
                        () => {
                            this.refresh();
                            Vue.swal.fire({
                                title: 'Kanał został zedytowany!',
                                icon: 'success',
                                timer: 1000,
                                showConfirmButton: false,
                            });
                        },
                        error => {
                            this.loading = false;
                            console.log(error);
                        }
                    );
                }
            });
        },
        canAddSubChannel(channel) {
            return channel.children.length < channel.config.maxSubChannels && channel.config.editable;
        },
        addSubChannel(pid) {
            this.currentChannel = null;
            this.newSubChannel = {
                pid: pid,
                maxClients: -1,
                name: 'Nowy kanał',
            };
            this.editForm = false;
        },
        saveAddSubChannel() {
            this.loading = true;
            this.$validator.validateAll('add').then(isValid => {
                if (!isValid) {
                    this.loading = false;
                    return;
                }

                if (this.newSubChannel) {
                    ManageChannelsService.addSubChannel(this.newSubChannel).then(
                        () => {
                            this.refresh();
                            Vue.swal.fire({
                                title: 'Kanał został dodany!',
                                icon: 'success',
                                timer: 1000,
                                showConfirmButton: false,
                            });
                        },
                        error => {
                            this.loading = false;
                            console.log(error);
                        }
                    );
                }
            });
        },
        canBeDeleted() {
            let mainChannels = [];

            this.channels.forEach(channel => {
                mainChannels.push(channel.cid);
            });

            return mainChannels.includes(this.currentChannel.pid);
        },
        deleteSubChannel() {
            let cid = this.currentChannel.cid;

            Vue.swal.fire({
                title: 'Jesteś pewny?',
                text: "Nie będziesz mógł cofnąć tej operacji!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Tak, usuń!',
                cancelButtonText: 'Anuluj'
            }).then((result) => {
                if (result.value) {
                    this.loading = true;

                    ManageChannelsService.deleteSubChannel(cid).then(
                        () => {
                            this.refresh();

                            Vue.swal.fire({
                                title: 'Usunięto podkanał!',
                                icon: 'success',
                                timer: 1000,
                                showConfirmButton: false,
                            });
                        },
                        error => {
                            this.loading = false;
                            console.log(error)
                        }
                    );
                }
            });
        },
        async createMeeting() {
            this.loading = true;

            ManageChannelsService.getOnlineClients().then(
                async (response) => {
                    let clients = response.data.onlineClients;
                    let ComponentClass = Vue.extend(SelectOnline);
                    let vueFormInstance = new ComponentClass({
                        propsData: {clients: clients, onlyOne: false, allChecked: true, idType: "clid"}
                    });

                    const {value} = await Vue.swal.fire({
                        title: 'Wybierz użytkowników',
                        html: '<div id="clients"></div>',
                        showCancelButton: true,
                        confirmButtonText: 'Ok',
                        cancelButtonText: 'Anuluj',
                        showLoaderOnConfirm: true,
                        onBeforeOpen: () => {
                            vueFormInstance.$mount();
                            document.getElementById("clients").appendChild(vueFormInstance.$el);
                        },
                        preConfirm: () => {
                            let result = vueFormInstance.getResults();
                            vueFormInstance.$destroy();
                            vueFormInstance = null;
                            return result;
                        }
                    });

                    if (value) {
                        ManageChannelsService.createMeeting(value, this.currentChannel.cid).then(
                            (response) => {
                                this.refresh();

                                Vue.swal.fire({
                                    title: 'Utworzono spotkanie!',
                                    text: response.data.info,
                                    icon: 'success',
                                    timer: 1000,
                                    showConfirmButton: false,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    } else
                        this.loading = false;
                },
                error => {
                    this.loading = false;
                    console.log(error)
                }
            );
        },

        deleteClientChannelGroup(cgid, dbid) {
            let cid = this.currentChannel.cid;

            Vue.swal.fire({
                title: 'Jesteś pewny?',
                text: "Nie będziesz mógł cofnąć tej operacji!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Tak, usuń!',
                cancelButtonText: 'Anuluj'
            }).then((result) => {
                if (result.value) {
                    this.loading = true;

                    ManageChannelsService.deleteClientChannelGroup(cid, cgid, dbid).then(
                        () => {
                            this.refresh();

                            Vue.swal.fire({
                                title: 'Usunięto użytkownika z grupy kanałowej!',
                                icon: 'success',
                                timer: 1000,
                                showConfirmButton: false,
                            });
                        },
                        error => {
                            this.loading = false;
                            console.log(error)
                        }
                    );
                }
            });
        },

        async addClientChannelGroup(cgid) {
            ManageChannelsService.getOnlineClients().then(
                async (response) => {
                    let clients = response.data.onlineClients;
                    let ComponentClass = Vue.extend(SelectOnline);
                    let vueFormInstance = new ComponentClass({
                        propsData: {clients: clients, onlyOne: true, allChecked: false, idType: "dbid"}
                    });

                    const {value} = await Vue.swal.fire({
                        title: 'Wybierz użytkownika',
                        html: '<div id="clients"></div>',
                        showCancelButton: true,
                        confirmButtonText: 'Ok',
                        cancelButtonText: 'Anuluj',
                        showLoaderOnConfirm: true,
                        onBeforeOpen: () => {
                            vueFormInstance.$mount();
                            document.getElementById("clients").appendChild(vueFormInstance.$el);
                        },
                        preConfirm: () => {
                            let result = vueFormInstance.getResults();
                            vueFormInstance.$destroy();
                            vueFormInstance = null;
                            return result;
                        }
                    });

                    if (value) {
                        ManageChannelsService.addClientChannelGroup(this.currentChannel.cid, cgid, value).then(
                            () => {
                                this.refresh();

                                Vue.swal.fire({
                                    title: 'Dodano użytkownika do grupy!',
                                    icon: 'success',
                                    timer: 1000,
                                    showConfirmButton: false,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    }
                },
                error => {
                    this.loading = false;
                    console.log(error)
                }
            );
        },

        async movedSubChannel(pid, children) {
            this.loading = true;
            let order = [];

            for await (let info of children)
                order.push(info.cid);

            ManageChannelsService.movedSubChannel(pid, order).then(
                () => {
                    this.refresh();
                    Vue.swal.fire({
                        title: 'Przesunięto kanał pomyślnie!',
                        icon: 'success',
                        timer: 1000,
                        showConfirmButton: false,
                    });
                },
                error => {
                    this.loading = false;
                    console.log(error)
                }
            );

        }

    }
};
</script>

<style>
.ts-channels ul {
    list-style: none;
}

.position-sticky {
    top: 10%;
}

.channels-list {
    padding-left: 0;
}
</style>
